import React from "react";
import Newsletter_39 from "../component/Newsletter_39";

function Newsletter_39Container() {
  return <Newsletter_39 />;
}

export default Newsletter_39Container;
